<template>
  <Dialog :commonDialog="dialog" :dialogWidth="dialogWidth">
    <template v-slot:title>
      <v-layout>
        <v-flex>Manage Product Specialists</v-flex>
        <v-flex class="text-right">
          <v-btn
            depressed
            small
            class="mx-4 white--text"
            color="cyan"
            v-on:click="createProductSpecialist"
          >
            <span class="font-size-16 font-weight-600"
              >Add Product Specialist</span
            >
          </v-btn>
        </v-flex>
      </v-layout>
    </template>
    <template v-slot:body>
      <perfect-scrollbar
        :options="{ suppressScrollX: true }"
        class="scroll custom-box-top-inner-shadow"
        style="max-height: 90vh; position: relative"
      >
        <v-form
          ref="productSpecialistForm"
          v-model.trim="formValid"
          lazy-validation
          v-on:submit.stop.prevent="updateProductSpecialists"
        >
          <v-container class="py-0">
            <v-row class="py-0">
              <v-col md="12" class="py-0">
                <table class="width-100">
                  <tbody>
                    <tr
                      v-for="(specialist, index) in productSpecialistList"
                      :key="index"
                    >
                      <td>
                        <v-text-field
                          v-model.trim="specialist.text"
                          dense
                          filled
                          placeholder="Enter Product Specialist"
                          solo
                          flat
                          class="px-4 py-2"
                          hide-details
                          :disabled="pageLoading"
                          :loading="pageLoading"
                          :rules="[
                            validateRules.required(
                              specialist.text,
                              'Product Specialist'
                            ),
                          ]"
                          color="cyan"
                        ></v-text-field>
                      </td>
                      <td width="50" v-if="productSpecialistList.length > 1">
                        <v-tooltip top content-class="custom-top-tooltip">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              v-on:click="deleteProductSpecialist(index)"
                              color="deep-orange"
                              v-bind="attrs"
                              v-on="on"
                              >mdi-delete</v-icon
                            >
                          </template>
                          <span>Click here to delete</span>
                        </v-tooltip>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </perfect-scrollbar>
    </template>
    <template v-slot:action>
      <v-btn
        depressed
        :disabled="pageLoading || !formValid"
        :loading="pageLoading"
        class="mx-2 custom-grey-border custom-bold-button white--text"
        color="cyan"
        v-on:click="updateProductSpecialists"
      >
        Save
      </v-btn>
      <v-btn
        depressed
        :disabled="pageLoading"
        class="mx-2 custom-grey-border custom-bold-button"
        v-on:click="$emit('close-dialog', true)"
      >
        Close
      </v-btn>
    </template>
  </Dialog>
</template>

<script>
import Dialog from "@/view/pages/partials/Dialog.vue";
import { GET, PATCH } from "@/core/services/store/request.module";
import { ErrorEventBus, InitializeError } from "@/core/lib/message.lib";
import ValidationMixin from "@/core/plugins/validation-mixin";
import CommonMixin from "@/core/plugins/common-mixin";
import { cloneDeep } from "lodash";

export default {
  mixins: [ValidationMixin, CommonMixin],
  props: {
    dialog: {
      type: Boolean,
      required: true,
      default: false,
    },
    product_specialists: {
      type: Array,
      default: () => {
        return new Array();
      },
    },
  },
  watch: {
    product_specialists: {
      deep: true,
      immediate: true,
      handler(param) {
        this.productSpecialistList = cloneDeep(param);
      },
    },
  },
  data: () => {
    return {
      formValid: true,
      pageLoading: false,
      productSpecialistList: [
        {
          text: null,
        },
      ],
    };
  },
  methods: {
    getProductSpecialists() {
      const _this = this;
      _this.pageLoading = true;
      _this.$store
        .dispatch(GET, { url: "setting/product-specialist" })
        .then((response) => {
          const list = response?.data?.product_specialists || [];
          _this.productSpecialistList = list.length
            ? cloneDeep(list)
            : [{ text: null }];
          _this.$emit("get-product-specialists", cloneDeep(list));
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.pageLoading = false;
        });
    },
    updateProductSpecialists() {
      const _this = this;
      const formErrors = _this.validateForm(_this.$refs.productSpecialistForm);

      if (formErrors.length) {
        for (let i = 0; i < formErrors.length; i++) {
          ErrorEventBus.$emit("update:error", InitializeError(formErrors[i]));
          _this.pageLoading = false;
        }
        return false;
      }

      if (!_this.$refs.productSpecialistForm.validate()) {
        return false;
      }

      _this.pageLoading = true;
      _this.$store
        .dispatch(PATCH, {
          url: "setting/product-specialist",
          data: { product_specialist: _this.productSpecialistList },
        })
        .then(() => {
          _this.$emit("close-dialog", true);
          _this.getProductSpecialists();
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.pageLoading = false;
        });
    },
    createProductSpecialist() {
      this.productSpecialistList.push({
        text: null,
      });
    },
    deleteProductSpecialist(index) {
      if (this.productSpecialistList.length > 1) {
        this.productSpecialistList.splice(index, 1);
      }
    },
  },
  components: {
    Dialog,
  },
  computed: {
    dialogWidth() {
      return this.lodash.toSafeInteger((document.body.clientWidth / 100) * 50);
    },
  },
};
</script>
